<app-content-header text="Change Payment Methods"></app-content-header>

<div class="payment-list-container">
  <div class="d-flex align-items-center justify-content-between mb-2" *ngIf="primaryPaymentCreditCard !== null">
      <div class="payment-list-title">Primary Payment Method</div>
  </div>
  <app-payment-tile
    *ngIf="!primaryPaymentCreditCard.expired"
    [creditCard]="primaryPaymentCreditCard"
    [selectedCreditCard]="selectedPaymentCreditCard"
    [showRadio]="true"
    (selectedChange)="setSelectedPaymentMethod($event)"
  ></app-payment-tile>
</div>

<div class="payment-list-container">
  <div class="payment-list-title mb-2">Other Payment Methods</div>
  <ng-container *ngFor="let creditCard of otherPaymentCreditCardList; index as i">
    <app-payment-tile
      [creditCard]="creditCard"
      [selectedCreditCard]="selectedPaymentCreditCard"
      [showRadio]="true"
      (selectedChange)="setSelectedPaymentMethod($event)"
    ></app-payment-tile>
  </ng-container>
</div>

<!-- Button -->
<hr class="bottom-divider" />
<footer class="footer-action">
  <button
    class="btn btn-danger btn-block"
    (click)="onSave()"
  >Save</button>
</footer>
